/* global $defaConfig */

import { Translator }   from 'i18n/i18n';
import { $, _, Bb, Mn } from 'tools';

/**
 * Creates the defa object, to expose all classes, objects and vars in the console.
 * !TODO: functions like setInternalEnvironment() or isWeb should be requests in a radio channel.
 * @void
 */
class DefaRegistry {
	
	/**
	 * @constructor
	 */
	constructor() {
		// extend object if it already exists
		if ( window.defa ) {
			Object.assign( this, window.defa );
		}
		
		// setup the defa.vars
		this.vars = Object.assign( this.vars || {}, {
			// Constants from assets.scala.html
			base       : '/',
			baseURI    : $defaConfig.baseURI,
			apiHost    : $defaConfig.baseURI + '/api',
			namesDays  : [ 'Mon', 'Tue', 'Wen', 'Thu', 'Fri', 'Sat', 'Sun' ],
			namesMonths: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
			hours      : 'hrs',
		} );
		
		// other attributes used
		this.objects      = {};
		this.behaviors    = {};
		this.applications = {};
		this.controllers  = {};
		this.collections  = {};
		this.views        = {};
		this.routers      = {};
		this.services     = {};
		this.models       = {};
		
		this.dependencies = {
			Mn, Bb, $, _
		};
	}
	
	// TODO this, and the module files may be removed.
	registerModule( module ) {
		let contents = module.contents;
		for ( let kind in contents ) {
			this[ kind ] = this[ kind ] || {};
			for ( let item in contents[ kind ] ) {
				if ( this[ kind ][ item ] ) {
					//console.warn( `${ kind }.${ item } already installed. Overwritten by ${ module.name }` );
				}
				this[ kind ][ item ] = contents[ kind ][ item ];
			}
		}
		//console.log( `Module registered: ${ module.name }` );
	}
	
	registerModules( modules ) {
		modules.forEach( m => this.registerModule( m ) );
	}
	
	/**
	 *  Use get params to set the app in android, webkit or toyota state.
	 *  State is saved in local storage.
	 *  Use "blank" to reset the parameters.
	 *  Examples:
	 *  https://defaservices043:8082?toyota         <-- will set toyota true.
	 *  https://defaservices043:8082?toyota&android <-- will set toyota and android true
	 *  https://defaservices043:8082?blank          <-- will reset to web version
	 */
	setInternalEnvironment() {
		
		// !TODO: For continuity, use Underscore's _.each instead of .forEach.
		
		let detects = [ 'android', 'webkit', 'toyota' ];
		
		let search = window.location.search
						   .replace( /^\?/, '' )
						   .split( '&' )
						   .map( v => v.split( '=' ) )
						   .reduce( ( acc, current ) => {
							   acc[ current[ 0 ] ] = current[ 1 ] || true;
							   return acc;
						   }, {} );
		
		if ( search.blank !== undefined ) {
			detects.forEach( term => {
				window.localStorage.removeItem( term );
			} );
			return;
		}
		
		detects.forEach( term => {
			let value = search[ term ];
			
			if ( value ) {
				window.localStorage.setItem( term, search[ term ] );
			} else {
				value = window.localStorage.getItem( term );
			}
			
			// Note: these vars may be set by an external app as well, so make sure to not overwrite existing vars.
			if ( value ) {
				this.vars[ term ] = this.vars[ term ] || value;
			}
		} );
	}
}

export const defa = new DefaRegistry();

export const T = new Translator();
